import profileImage from '../assets/images/Image_06.png';
// import CoatingImage from "../assets/images/coating-facility.png"; // You'll need to add this image
import PageHeader from '@/components/PageHeader';

function OurExpertise() {
  return (
    <div className="font-sans">
      <PageHeader title='Our Expertise' imageUrl={profileImage} breadcrumbs={['Home', 'Our Expertise']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          Our Expertise
        </h2>

        <div className="space-y-16">

          {/* Company Overview Section */}
          <section>
            <h3 className="text-lg font-bold text-[#05326D] flex items-center gap-2 mb-6">
              <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
              About FDAC Advanced Solutions
            </h3>
            <div className="text-sm text-[#05326D] space-y-4">
              <p>
                FDAC Advanced Solutions Pvt. Ltd. is a specialized organization providing advanced quality and regulatory affairs solutions
                to the pharmaceutical industry. With offices in Mumbai and Pune, we bring together a highly experienced team with expertise
                across multiple domains of pharmaceutical manufacturing and compliance.
              </p>
            </div>
          </section>

          {/* Core Competencies Section */}
          <section>
            <h3 className="text-lg font-bold text-[#05326D] flex items-center gap-2 mb-6">
              <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
              Core Competencies
            </h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <ul className="list-none text-sm space-y-3 text-[#05326D]">
                  <li className="flex items-start space-x-3">
                    <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0 inline-block mt-2"></span>
                    <span><strong>Formulation and Coating Development:</strong> Comprehensive R&D support for developing tailored pharmaceutical formulations and coating systems</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0 inline-block mt-2"></span>
                    <span><strong>Quality Assurance and Regulatory Affairs:</strong> End-to-end compliance solutions ensuring adherence to global regulatory standards</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0 inline-block mt-2"></span>
                    <span><strong>Engineering and Plant Operations:</strong> Technical expertise in pharmaceutical manufacturing operations and plant setup</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0 inline-block mt-2"></span>
                    <span><strong>Color Matching and Technical Support:</strong> Specialized services for achieving consistent batch-to-batch color uniformity</span>
                  </li>
                </ul>
              </div>
              <div className="space-y-4">
                <ul className="list-none text-sm space-y-3 text-[#05326D]">
                  <li className="flex items-start space-x-3">
                    <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0 inline-block mt-2"></span>
                    <span><strong>Documentation and Validation:</strong> Complete validation support including VMP, process validation, and EXCiPACT GMP compliance</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0 inline-block mt-2"></span>
                    <span><strong>Equipment Qualification:</strong> DQ, IQ, OQ, and PQ support for manufacturing and analytical equipment</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0 inline-block mt-2"></span>
                    <span><strong>Vendor Qualification:</strong> Raw material specifications and vendor auditing services</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0 inline-block mt-2"></span>
                    <span><strong>Training and Development:</strong> Comprehensive team training across QA, QC, Production, and Engineering departments</span>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          {/* Specialized Services Section */}
          <section>
            <h3 className="text-lg font-bold text-[#05326D] flex items-center gap-2 mb-6">
              <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
              Comprehensive In-House Coating Excipient Solutions for Drug Formulation Manufacturers and New Ventures
            </h3>

            <div className="flex flex-col md:flex-row items-start gap-8">
              <div className="md:w-2/3 text-sm text-[#05326D] space-y-6">
                <p>
                  We offer end-to-end support for setting up in-house manufacturing facilities for dry ready-mix coating excipients.
                  Our flagship solution is designed to empower pharmaceutical manufacturers—whether established or new—to produce high-quality,
                  customized coating materials directly on-site.
                </p>

                <p>
                  This approach addresses the growing demand for cost-effective,
                  tailored coating systems while ensuring adherence to the highest quality standards.
                </p>

                <div className="bg-gray-50 p-6 rounded-lg">
                  <h4 className="font-bold mb-4 text-[#05326D]">Why Choose In-House Production?</h4>
                  <ul className="list-none space-y-2">
                    <li className="flex items-center space-x-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#B5AB28] flex-shrink-0"></span>
                      <span>Significant Cost Savings
                        Reduce reliance on external suppliers and lower overall production costs.</span>
                    </li>
                    <li className="flex items-center space-x-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#B5AB28] flex-shrink-0"></span>
                      <span>Improved Inventory Management
                        Gain greater control over inventory and enhance planning flexibility.</span>
                    </li>
                    <li className="flex items-center space-x-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#B5AB28] flex-shrink-0"></span>
                      <span>Customization Capabilities
                        Formulate coating systems tailored to your specific product requirements.
                      </span>
                    </li>
                    <li className="flex items-center space-x-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#B5AB28] flex-shrink-0"></span>
                      <span>Complete Quality Control
                        Maintain full oversight of raw materials and finished coating products to ensure consistent quality.</span>
                    </li>
                  </ul>
                </div>

                <h4 className="font-bold text-[#05326D] mt-8 mb-4">Turnkey Implementation of Dry Ready-Mix Coating Excipients for Oral Solid Dosage Forms
                </h4>
                <p>
                  We offer end-to-end, turnkey project implementation for dry ready-mix coating excipients used in oral solid dosage forms. Our comprehensive approach covers every stage—from R&D setup and process development to establishing GMP-compliant manufacturing facilities and ensuring commercial production readiness. As strategic partners, we operate with complete confidentiality and take full ownership of project execution, ensuring successful and timely outcomes.
                </p>

                <div className="grid md:grid-cols-2 gap-4 mt-6">
                  <div className="space-y-2">
                    <h5 className="font-semibold text-[#05326D]">Phase 1 Deliverables:</h5>
                    <ul className="text-xs space-y-1">
                      <li>• R&D and coating area design</li>
                      <li>• cGMP compliant infrastructure</li>
                      <li>• Formulation development</li>
                      <li>• SOPs for all operations</li>
                    </ul>
                  </div>
                  <div className="space-y-2">
                    <h5 className="font-semibold text-[#05326D]">Ongoing Support:</h5>
                    <ul className="text-xs space-y-1">
                      <li>• Team training across departments</li>
                      <li>• Validation and compliance</li>
                      <li>• Equipment qualification</li>
                      <li>• Regulatory support</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="md:w-1/3 w-full">
                <div className="bg-gradient-to-b from-blue-50 to-blue-100 p-6 rounded-lg">
                  <h4 className="font-bold text-[#05326D] mb-4">Contact Our Experts</h4>
                  <div className="space-y-3 text-sm">
                    <div>
                      <p className="font-semibold text-[#05326D]">Dr. Ashok Omray</p>
                      <p className="text-xs text-gray-600">Director</p>
                    </div>
                    <div className="space-y-1 text-xs">
                      <p>📱 +91-9967006346</p>
                      <p>📧 ashokomray@fdacadvancedsolutions.com</p>
                      <p>📧 svichare@fdacadvancedsolutions.com</p>
                    </div>
                    <div className="pt-2 border-t border-blue-200">
                      <p className="text-xs font-semibold text-[#05326D] mb-1">Offices:</p>
                      <div className="text-xs space-y-2">
                        <div>
                          <p className="font-medium">Mumbai:</p>
                          <p>C/501, Redwoods, Vasant Gardens, Off L.B.S. Road, Mulund (W), Mumbai 400080</p>
                        </div>
                        <div>
                          <p className="font-medium">Pune:</p>
                          <p>Hall No-101 and 105 Ecoshoppy Namrata Varale, Maval, Pune – 410507</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Service Approach Section */}
          <section>
            <h3 className="text-lg font-bold text-[#05326D] flex items-center gap-2 mb-6">
              <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
              Our Service Approach
            </h3>
            <div className="text-sm text-[#05326D] space-y-4">
              <p>
                FDAC operates on a partnership model, working closely with client R&D and F&D teams to develop customized
                solutions that meet both local and international regulatory requirements. We bring end-to-end expertise from
                R&D to commercial scale, ensuring coating systems are cost-effective, compliant, and consistent.
              </p>
              <p>
                Our commitment extends beyond project delivery. We treat all client engagements with complete confidentiality
                and professionalism, approaching each project as a strategic partnership with full ownership accountability—
                much like a joint venture focused on mutual success.
              </p>
            </div>
          </section>

          {/* Industries Served */}
          <section>
            <h3 className="text-lg font-bold text-[#05326D] flex items-center gap-2 mb-6">
              <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
              Industries & Applications
            </h3>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-sky-50 p-4 rounded-lg">
                <h4 className="font-semibold text-[#05326D] mb-2">Pharmaceutical Manufacturing</h4>
                <p className="text-sm text-[#05326D]">Solid oral dosage forms, tablet coating systems, and formulation development</p>
              </div>
              <div className="bg-sky-50 p-4 rounded-lg">
                <h4 className="font-semibold text-[#05326D] mb-2">Regulatory Compliance</h4>
                <p className="text-sm text-[#05326D]">EXCiPACT GMP standards, FDA guidelines, and international regulatory requirements</p>
              </div>
              <div className="bg-sky-50 p-4 rounded-lg">
                <h4 className="font-semibold text-[#05326D] mb-2">Quality Systems</h4>
                <p className="text-sm text-[#05326D]">Quality assurance, process validation, and documentation management</p>
              </div>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
}

export default OurExpertise;